<template>
  <div :class="['registration-container', {'side_gaps': !selectedStep(1), 'has_left-bar': currentStep === 1 }]">
    <div class="registration-header" v-if="!selectedStep(1)">
      <router-link to="/register" >
        <img src="../../public/images/small-logo.svg" alt="logo" class="registration__logo">
      </router-link>
    </div>
    <div :class="['registration-content', 'registration_module', isMobileDevice ? 'mobile-view' : 'desktop-view']">
      <step-one
          :context="context"
          v-if="selectedStep(1)"
          @onSubmit="nextStep"
          @onNavToPrevForm="prevStep"
      />
      <step-two
          :context="context"
          @onSubmit="nextStep"
          @onNavToPrevForm="prevStep"
          v-if="selectedStep(2)"
      />
      <step-three
          @onNavToPrevForm="prevStep"
          v-if="selectedStep(3)"
      />
      <form-header class="hidden-mobile" v-if="!selectedStep(1)" :selected-step="currentStep" />
    </div>

  </div>
</template>

<script>
import StepOne from "../components/StepOne";
import StepTwo from "../components/StepTwo";
import StepThree from "../components/StepThree";
import FormHeader from "../components/FormHeader";
import axios from "axios";
import {isMobile} from "@/common/osChecker";

export const API_URL = process.env.VUE_APP_SERVER_URL
  ? process.env.VUE_APP_SERVER_URL
  : "https://croinc.bearle.ru";

export default {
  name: "app",
  components: {
    StepThree,
    StepTwo,
    StepOne,
    FormHeader
  },
  props: ['invite'],
  data() {
    return {
      context: {
        companyName: null,
        country: null,
        timezone: null,
        phone: "",
        mail: null,
        user_name: "",
        pass: "",
        passAgain: "",
        selectedCompanyId: null,

        registrationType: null,
        url: "",
        name: "",
        image: "",
        inn: "",
        ogrn: "",
        imageUrl: '',
        address: null,
        city: null,
        metro: null,
        lat: 55.753215,
        long: 37.622504,
        timeOfWork: [],
        isGenderableServices: false,
        addedCategories: [],
        employees: [],

      },
      currentStep: 1,
    };
  },

  mounted() {
    if (this.invite){
      axios.get(`${API_URL}/api/v1/stats/register_open?invite=${this.invite}`)
    }
    if (this.$route.params.emailtoken) {
      this.currentStep = 3;
    }
  },
  computed: {
    isMobileDevice() {
      return isMobile() || false;
    }
  },
  methods: {
    nextStep(){
      if(this.currentStep === 2) {
        this.submitData();
      } else {
        this.currentStep += 1;
      }
    },
    prevStep(){
      this.currentStep -= 1;
    },
    selectedStep(step) {
      return this.currentStep == step;
    },
    submitData() {
      let formData = new FormData();
      //step one
      formData.append("company_name", this.context.companyName || "");
      formData.append("country", this.context.country || "");
      formData.append("timezone",   this.context.timezone || "");
      formData.append("phone", this.context.phone || "-");
      formData.append("mail", this.context.mail || "");
      //step two
      formData.append("user_name", this.context.user_name || "");
      formData.append("password", this.context.pass || "");
      formData.append("url", this.context.url || '');
      formData.append("invite", this.invite || "");

      const self = this;
      axios
        .post(
          `${API_URL}/api/v1/admin/auth/register/`, formData)
          .then(response => {
            const user = response.data;
            let accepted = localStorage.getItem("agreement");
            if (accepted !== "true") {
              localStorage.setItem("agreement", "false");
            }
            // successful go to third screen
            if (response.status === 200) {
              this.currentStep +=1
            }
        }).catch(function(error) {
          self.$message({ message: error.response.data, type: "error" });
        });
    }
  }
};
</script>
<style lang="sass">
  @import '@/assets/_promo-auth'
</style>
